import { ActionContext } from 'vuex';

import { FilterTypeEnum } from '../../../enums';

import { ActionClass, ContextState, Filter } from '../../../models';

import { CONTEXT_CONSTS } from '../../../store/context/context.consts';

export class ClearFiltersAction implements ActionClass {

  public static execute({ dispatch, getters }: ActionContext<ContextState, any>): Promise<void> {
    const selectedValues = {};
    Object.values(getters[CONTEXT_CONSTS.getters.enabledFilters]).forEach((filter: Filter) => {
      if (!filter.config.mandatory) {
        selectedValues[filter.config.id] = {
          [FilterTypeEnum.DATE]: [undefined, undefined],
          [FilterTypeEnum.REALTIME]: undefined,
          [FilterTypeEnum.REGULAR]: []
        }[filter.config.type];
      }
    });
    return dispatch(CONTEXT_CONSTS.actions.setFiltersSelectedValues, selectedValues);
  }

}
